module.exports = __webpack_public_path__ + "static/media/skull-cow.e4ebd7fb.svg";